import { useSelector } from 'react-redux'

import { selectChatIntentTypes } from '../../../../accessors/index'
import { ReactComponent as Close } from './close.svg'
import styles from './IntentSelector.module.scss'

const Button = ({ children, handleClick }) => (
  <button className={styles.intentButton} onClick={handleClick}>
    {children}
  </button>
)

const IntentSelector = ({ y, x, handleClose, handleSelect, count, title }) => {
  const intentTypes = useSelector(selectChatIntentTypes)

  return (
    <div className={styles.wrapper} style={{ top: `${y}px`, left: `${x}px` }}>
      <div className={styles.container}>
        <button onClick={handleClose} className={styles.closeButton}>
          <Close />
        </button>
        <div className={styles.title}>
          {title || (
            <>
              Categorize {count} message{count > 1 ? 's' : ''}
            </>
          )}
        </div>
        {Object.keys(intentTypes).map(k => (
          <Button handleClick={() => handleSelect(k)} key={k}>
            {intentTypes[k].name}
          </Button>
        ))}
      </div>
    </div>
  )
}

export default IntentSelector
